import { network } from 'services/network';

export const getBoardWbsInit = (params) => {
    const url = `api/bo/getBoardWbsInit?versionId=${params.versionId}`;

    return network.get(url).then((response) => {
        return response.data.wbsList;
    });
};
